/* eslint-disable max-len */
import BoneQuestion from 'images/coin-pages/questions/brise.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const brisePage: ICoinPageData = {
  title: 'coin_195',
  description: 'coin_196',
  // description: 'coin_197',
  h1: (t: (key: unknown) => any) => (
    <>
      {t('borrow_against_bone')} <span style={{ color: '#f90' }}>Brise</span>
    </>
  ),
  questionsBlock: {
    image: BoneQuestion,
    questions: [
      {
        title: 'coin_198',
        answer: 'coin_199',
      },
      {
        title: 'coin_200',
        answer: 'coin_201',
      },
      {
        title: 'coin_202',
        answer: 'coin_203',
      },
      {
        title: 'coin_204',
        answer: 'coin_205',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('BRISE (BRISE)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_206',
        text: ['coin_208'],
      },
      {
        title: 'coin_207',
        text: ['coin_209'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-brise-and-how-to-use-it-to-gain-profit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2023/04/Brise.png',
        imageAlt: 'BRISE Crypto loans – All You Need to Know',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
